<template>
  <div class="index-layout" :class="layoutClass">
    <div class="scroll-box" @scroll="scrollTrigger">
      <loading v-show="loading"></loading>
      <div class="slide-inner" v-show="!loading" :style="'width:'+layoutWidth">
        <card class="card-min detail-card" size="max" v-for="(card,index) in minCards" :key="index">
          <div slot="content">
            <div class="card-head">
              <p class="title">{{card.title}}</p>
              <p class="subTitle" v-if="card.subTitle">{{card.subTitle}}</p>
            </div>
            <div class="card-image" :style="{backgroundImage: 'url('+ card.content.url+')'}">
            </div>
            <div class="card-info" v-html="card.contentInfo"></div>
          </div>
        </card>
        <!-- 可以使用公共结构的 -->
        <card class="detail-card" v-for="(cardobj,OperateTime,index) in cardTable" :key="index" size='max'
              :styleObject="styleObject">

          <div slot="head" class="zoom" style="overflow: hidden">
            <span class="card-index">{{cardobj.index}}</span>
            <div class="card-head" :style="cardobj.cardInfo.width ? {width: cardobj.cardInfo.width-60 + 'px'} : {}">
              <p class="card-head-title"><span class="card-head-title-txt"
                                               :style="cardobj.cardInfo.headTtitleWidth">{{cardobj.cardInfo.title}}</span><span
                class="iconfont icon-jchg" v-if="cardobj.cardInfo.extraTitleInfo == 1"></span></p>
              <p class="card-head-subtitle" v-if="cardobj.cardInfo.subTitle">{{cardobj.cardInfo.subTitle}}</p>
            </div>
            <div class="diaBtn">
              <div @click="blockShow($event)" v-if="cardobj.cardInfo.diaBtnIcon1"><i class="diaBtnIcon diaBtnIcon1"></i>满天星区块链查证
              </div>
              <div @click="stampShow($event)" v-if="cardobj.cardInfo.diaBtnIcon2"><i class="diaBtnIcon diaBtnIcon2"></i>可信时间戳认证
              </div>
            </div>
          </div>
          <div slot="content" class="card-col" :style="colWidth ? {width: colWidth + 'px'} : ''"
               v-for="(col,colIndex) in cardobj.cols" :key="colIndex">
            <div class="card-row zoom" v-for="(row,rowIndex) in col" :key="rowIndex">
              <span class="card-row-key" v-if="!row.hideTitle">{{row.title}}</span>
              <div class="card-row-value" :class="{'card-row-value-withoutKey': row.hideTitle}" v-if="row.width">
                <img :src="row.content" ref="zoomImgs" @load="imageLoadHandler(rowIndex)"
                     :style="{width: row.width + 'px'}" @click="clickImg(row)">
              </div>
              <div class="card-row-value" v-else>{{row.content}}</div>
            </div>
          </div>
        </card>
      </div>
    </div>
    <!--区块链弹窗-->
    <div ref="blockDialog" class="blockDialog">
      <div class="closeBlock" @click="closeBlock"><img src="../../../static/close.png" alt=""></div>
      <div class="blockTitle">满天星区块链认证信息</div>
      <div slot="content" class="card-content-fixed">
        <div class="slide-blockchain">
          <ul style="padding: 0 0.2rem 0 0">
            <li v-for="(item,index) in blockchain.list" :key="index" v-if="item.content"
                class="card-blockchain-item zoom">
              <span class="blockchain-title">{{item.title}}</span>
              <span class="blockchain-content">{{item.content}}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="blockFoot">*该信息自申请满天星区块链起，内容保持完整，未被修改。</div>
      <div class="blockIcon"><img src="../../../static/blockchain.png" alt=""></div>
    </div>
    <!--时间戳弹窗-->
    <div ref="stampDialog" class="stampDialog">
      <div class="closeStamp" @click="closeStamp"><img src="../../../static/close.png" alt=""></div>
      <div class="stampTitle">可信时间戳认证信息</div>
      <div class="stampImg">
        <img :src="imagesUrl" alt="" ref="stampImg" @click="showStampImg">
        <div class="imgSub">可信时间戳认证证书</div>
      </div>
      <div slot="content" class="card-content-fixed">
        <div class="slide-stamp">
          <ul style="padding: 0 0.2rem 0 0">
            <li v-for="(item,index) in stamp.list" :key="index" v-if="item.content"
                class="card-stamp-item zoom">
              <span class="stamp-title">{{item.title}}</span>
              <span class="stamp-content">{{item.content}}</span>
            </li>
            <li class="card-stamp-item zoom">
              <span class="stamp-title">时间戳签发机构</span>
              <span class="stamp-content">联合信任时间戳服务中心</span>
            </li>
          </ul>
        </div>
        <div class="stampFoot">*该信息自申请时间戳起，内容保持完整，未被修改。</div>
      </div>
      <div class="stampIcon"><img src="../../../static/stamp.png" alt=""></div>
    </div>
    <div class="mask" ref="mask" @click="closeBlock"></div>
    <div class="mask" ref="mask2" @click="closeStamp"></div>
  </div>
</template>
<script>
  import card from '@/components/common/card.vue'
  import loading from '@/components/common/loading.vue'
  import slide from '@/components/composite/slide'
  import enums from '@/enums/index.js'
  import envConfig from '@/config/env.js'
  import breakLines from '@/utils/breakLinesForCanvas.js'
  import { mapState } from 'vuex'
  import zgpaPath from '../../../static/zgpa.png';
  import zhonghualogoPath from '../../../static/zhonghualogo.png';
  import org from './org';
  // const cardSizeInfo = card.enums;
  const titleMaxWidth = 100;
  const contentMaxWidth = 374;
  const lineHeight = 34;
  let canvasSize = {};
  let imagesList = [];
  let timer = null;
  let genet = null; // 当前执行的generator函数实例
  let hasImage = false; // 在信息中没有图片的情况下，触发generator函数实例next，使得代码能够继续执行
  const calcImageSize = (src, callback) => {
    const img = new Image();
    let isSizeLoaded = false;
    const iv = setInterval(() => {
      if (isSizeLoaded) {
        clearInterval(iv);
      } else {
        if (img.width > 0 && img.height > 0) {
          isSizeLoaded = true;
          clearInterval(iv);
          callback({ width: img.width, height: img.height });
        }
      }
    }, 10);
    img.onerror = function () {
      if (!isSizeLoaded) {
        isSizeLoaded = true;
        clearInterval(iv);
        callback({ width: 0, height: 0 });
      }
    };
    img.onload = function () {
      if (!isSizeLoaded) {
        isSizeLoaded = true;
        clearInterval(iv);
        callback({ width: img.width, height: img.height });
      }
    };
    img.src = src;
  };
  const addImageInfo = (imgobj, urlParam, sizeDeterminedBy, maxWidth, maxHeight) => {
    const src = imgobj[urlParam];

    function onReady(size) {
      let width = size.width;
      let height = size.height;
      if (width != 0 && height != 0) {
        let LastWidth = width, LastHeight = height;
        if (maxWidth && sizeDeterminedBy == 'width') {
          LastWidth = maxWidth;
          LastHeight = LastWidth * height / width;
          if (maxHeight && LastHeight > maxHeight) {
            LastHeight = maxHeight;
            LastWidth = LastHeight * width / height;
          }
        }
        if (maxHeight && sizeDeterminedBy == 'height') {
          LastHeight = maxHeight;
          LastWidth = LastHeight * width / height;
          if (maxWidth && LastWidth > maxWidth) {
            LastWidth = maxWidth;
            LastHeight = LastWidth * height / height;
          }
        }
        imgobj.width = LastWidth;
        imgobj.height = LastHeight;
      }
    }

    imagesList.push(onReady);
    let isGoNext = false;
    calcImageSize(src, size => {
      onReady(size);
      imagesList.splice(imagesList.indexOf(onReady), 1);
      setTimeout(() => {
        if (!isGoNext && imagesList.length == 0) {
          isGoNext = true;
          genet.next();
        }
      }, 200);
    });
    //console.log(imagesList);
    setTimeout(() => {
      if (!isGoNext && imagesList.length == 0) {
        isGoNext = true;
        genet.next();
      }
    }, 200);
  };
  let doubleClick = null;

  export default {
    data() {
      let isMobile = false;
      let isAndroid = false;
      let isIos = false;
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        isMobile = true;
        isIos = true;
      } else if (/(Android)/i.test(navigator.userAgent)) {
        isMobile = true;
        isAndroid = true;
      }

      return {
        isMobile, isAndroid, isIos, isPc: !isMobile,
        resultCustomData: {},
        imagesUrl: '',
        layoutWidth: '',
        pageType: '',
        styleObject: {
          background: '#fff',
          width: 'auto',
          borderRadius: '0.16rem',
          height: '8rem'
        },
        layoutHeight: 'auto',
        cardTable: [],
        minCards: [],
        traceDataSave: [],
        traceNodeList: [],
        blockchainDataList: {},
        timeStamp: {},
        colWidth: 520,
        loading: true,
        colNum: 0,
        touchXY: { x: 0, y: 0 },
        isTouchMoved: false,
        isOnlyTouchStart: false,
        touchTriggerTime: 0,
        zooming: false,
        scrollTimeOut: null,
        blockchain: {
          'list': []
        },
        stamp: {
          'list': []
        },
      }
    },
    components: {
      card,
      slide,
      loading
    },
    computed: {
      ...mapState({ htmlFontSize: 'htmlFontSize' }),
      canvasSize: function () {
        return { x: this.colWidth, y: 6.62 * this.htmlFontSize }
      },
      layoutClass: function () {
        const lc = [];
        if (this.isMobile) {
          lc.push('is-mobile');
        }
        if (this.isAndroid) {
          lc.push('is-android');
        }
        if (this.isIos) {
          lc.push('is-ios');
        }
        if (this.isPc) {
          lc.push('is-pc');
        }
        if (this.pageType) {
          lc.push('page-type-' + this.pageType);
        }
        return lc;
      }
    },
    watch: {
      cardTable: {
        handler: function () {
          if (this.isPc) {
            this.layoutHeight = (this.$el.offsetHeight * 1 + 20) + 'px';
          }
          setTimeout(this.bindTouch, 100);
          setTimeout(this.bindTouch, 500);
          this.isShowFinger();
          setTimeout(this.isShowFinger, 200);
          setTimeout(this.isShowFinger, 500);
        },
        deep: true
      }
    },
    methods: {
      /**获取布局结构数据
       * @method  getLayoutData
       * @author sansengg
       * @version 2017-05-02
       * @param   {Array}       cardTable [description]
       * @return  {[type]}                [description]
       * 布局数据结构：
       * ()为字段说明
       * (table)
       * [
       * (card){
       *     cols:
       *     [
       *       (rows:)
       *       [
       *   (row){
       *           title: '',
       *           content: '',
       *           width: '',(图片才有width与height。)
       *           height: ''
       *         }
       *       ]
       *     ]
       *   }
       * ]
       */
      getLayoutData(cardTable = []) {
        let that = this;
        canvasSize = this.canvasSize;
        // 设置字体内容，以及在画布上的位置
        let rowLayout = {
          contentDrawY: 0,
          titleDrawY: 0,
          titleY: 20,
          contentY: 20
        }
        let tableData = [],
          colsData = [],
          rowsData = [],
          rowData = {};

        let canvas = document.createElement('canvas');
        // canvas.width = canvasSize.x;
        // canvas.height = canvasSize.y;
        let ctx = canvas.getContext('2d');
        ctx.fillRect(0, 0, canvasSize.x, canvasSize.y);
        ctx.font = '24px 微软雅黑';
        // 设置对齐方式
        ctx.textAlign = 'left';

        function resetCanvas() {
          that.colNum++;
          colsData.push(rowsData);
          rowsData = [];
          rowLayout = {
            contentDrawY: 0,
            titleDrawY: 0,
            titleY: 20,
            contentY: 20
          }
        }

        function drawTitle(title, tableIndex, rowIndex) {
          var result = breakLines.breakLinesForCanvas(title, titleMaxWidth, '24px 微软雅黑');
          rowLayout.titleY = 20;
          var drawY = Math.max(rowLayout.contentDrawY, rowLayout.titleDrawY);
          rowData = { title: title };
          if (drawY + rowLayout.titleY > canvasSize.y - lineHeight) {
            resetCanvas();
            drawY = 0;
          }

          result.forEach(function (line, index) {
            rowLayout.titleY += lineHeight;
            ctx.fillText(line, 0, drawY + rowLayout.titleY);
          });
          drawY += rowLayout.titleY;
          rowLayout.titleDrawY = drawY;
        }

        function deepClone(obj) {
          return JSON.parse(JSON.stringify(obj));
        }

        function drawContent(content, tableIndex, rowIndex) {
          rowLayout.contentY = 20;
          var drawY = Math.max(rowLayout.contentDrawY, rowLayout.titleDrawY) - rowLayout.titleY;
          if (typeof content == 'string') {
            var result = breakLines.breakLinesForCanvas(content, contentMaxWidth, '24px 微软雅黑');
            result.reduce((pre, line, index, arr) => {
              if (drawY + rowLayout.contentY > canvasSize.y - lineHeight) {
                rowData['content'] = pre;
                rowsData.push(deepClone(rowData));
                var title = rowData.title;
                rowData = {};
                drawTitle(title, tableIndex, rowIndex); //换行添加title
                resetCanvas();
                drawY = 0;
                pre = '';
              }
              if (index == arr.length - 1) {
                rowData['content'] = pre + line;
                rowsData.push(deepClone(rowData));
                rowData = {};
              }
              rowLayout.contentY += lineHeight;
              ctx.fillText(line, 146, drawY + rowLayout.contentY);
              return pre + line;
            }, '');
            //如果值为空，也给它显示出来
            // if(content == ''){
            //   rowsData.push(rowData);
            //   rowData = {};
            //   rowLayout.contentY += lineHeight;
            //   ctx.fillText('', 146, drawY + rowLayout.contentY);
            // }
          } else {
            content['ratio'] = content.ratio ? content.ratio : content.width / content.height;
            var imgHeight = contentMaxWidth / content.ratio, imgWidth = contentMaxWidth;
            if (imgHeight > canvasSize.y - 20) {
              imgHeight = canvasSize.y - 20;
              imgWidth = imgHeight * content.ratio;
            }
            if (drawY + imgHeight > canvasSize.y) {
              var title = rowsData[rowsData.length - 1].title;
              resetCanvas();
              drawY = 0;
              //title && drawTitle(title, tableIndex, rowIndex); //换行添加title
            }
            rowData['content'] = content.url;
            rowData['width'] = imgWidth;
            rowData['height'] = imgHeight;
            rowsData.push(deepClone(rowData));
            rowData = {};

            ctx.fillRect(146, drawY + rowLayout.contentY, imgWidth, imgHeight);
            rowLayout.contentY += imgHeight;
          }

          drawY += rowLayout.contentY;
          rowLayout.contentDrawY = drawY;
        }

        function getDataByCanvas() {
          tableData = [];
          for (var i = 0; i < cardTable.length; i++) {
            colsData = [];
            var card = cardTable[i];
            var rows = card.rows;
            for (var j = 0; j < rows.length; j++) {
              if (rows[j].val == '') { //没有内容则不显示
                continue;
              }
              var title = rows[j].key;
              var content = rows[j].val;
              content = breakLines.relaceChinesePunctuations(content);
              rows[j].val = content;
              drawTitle(title, i, j);
              drawContent(content, i, j);
            }
            tableData.push({ cols: colsData, cardInfo: card.cardInfo });
            resetCanvas() //为了保存最后一幅图
          }
        }

        getDataByCanvas();
        this.layoutWidth = this.colNum * 581 + tableData.length * 19 - 10 + 50;
        if (this.isPc) {
          this.layoutWidth = this.layoutWidth + 50;
        }
        this.layoutWidth = this.layoutWidth + 'px'; // 应该是-20左边距，但为了保险为-10
        return tableData;
      },
      // 溯源信息
      getTracingData() {
        const traceingBatchID = localStorage.getItem('traceingBatchID');
        if (traceingBatchID && traceingBatchID != '') {
          this.getTracingInfo(traceingBatchID);
        }
      },
      getTracingInfo(batchId) {
        let traceDataSave = localStorage.getItem('traceDataSave');
        let traceNodeList = null;
        if (traceDataSave) {
          traceDataSave = JSON.parse(traceDataSave);
          if (traceDataSave.batchId === batchId) {
            traceNodeList = traceDataSave.traceNodeList;
          }
        }
        if (traceNodeList) {
          this.setTracingNodeData(traceNodeList);
          this.traceNodeList = traceNodeList;
        } else {
          this.$ajax.get(this.$urlAPI.BaseData.getAndroidToken).then((result) => {
            if (result.Result == 200) {
              const token = result.Data.token;
              if (batchId && batchId != '') {
                this.$ajax.jsonp(this.$urlAPI.BaseData.GetProductBatchTraceNode, {
                  ProductBatchID: batchId,
                  Token: token
                }).then((result) => {
                  if (result.Result == 200 && result.Data.TraceNodeList) {
                    this.setTracingNodeData(result.Data.TraceNodeList);
                    this.traceNodeList = result.Data.TraceNodeList;
                  } else {
                    this.setTracingNodeData([]);
                  }
                }, () => {
                  // this.searchState = enums.ajaxState.failed
                });
              } else {
              }
            }
          });
        }
      },
      /**将溯源数据转换成待绘制数据结构
       * @method  getTracingCardTable
       * @author sansengg
       * @version 2017-05-02
       * @param   {[type]}            resultData [description]
       * @return  {[type]}                       [description]
       * cardTable 结构：[{rows:{key: '', val: ''}}]
       */
      getTracingCardTable(resultData) {
        let cardTable = [];
        hasImage = false;
        this.setblockchain();
        resultData.forEach((col, index, arr) => {
          let rowsArr = [];
          col.FieldList.forEach((row, index, arr) => {
            const fValue = row.FieldValue;
            if (row.FieldType == 2 && fValue.indexOf('url') > 0) { // 2时表示该字段展示的是图片,后面的判断是为了区分旧数据中
              const images = JSON.parse(fValue);
              let firstImgFlag = true;
              images.forEach((img, index, arr) => {
                if (img.url) {
                  addImageInfo(img, 'url', 'width', contentMaxWidth, this.canvasSize.y - 20);
                  hasImage = true;
                  /*firstImgFlag ? rowsArr.push({
                   key: row.FieldName,
                   _key: row.FieldName,
                   val: img
                   }) : rowsArr.push({key: '', _key: row.FieldName, val: img});*/
                  if (firstImgFlag) {
                    rowsArr.push({
                      key: row.FieldName,
                      _key: row.FieldName,
                      val: img
                    })
                  } else {
                    rowsArr.push({ key: '', _key: row.FieldName, val: img })
                  }
                  firstImgFlag = false;
                }
              });
            } else {
              if (row.FieldType != 2 && row.FieldValue !== '[]') {
                rowsArr.push({ key: row.FieldName, val: row.FieldValue });
              }
            }
          });
          if (this.blockchain.list.length > 0 && this.blockchain.list[index] && this.blockchain.list[index].main.length > 0) {
            cardTable.push({
              rows: rowsArr,
              cardInfo: {
                title: col.NodeName,
                subTitle: col.OperateTimeShowHidden == 1 ? col.OperateTime : '',
                orderBy: col.OperateTime,
                diaBtnIcon1: true,
                diaBtnIcon2: true
              }
            });
          } else {
            cardTable.push({
              rows: rowsArr,
              cardInfo: {
                title: col.NodeName,
                subTitle: col.OperateTimeShowHidden == 1 ? col.OperateTime : '',
                orderBy: col.OperateTime,
                diaBtnIcon1: false,
                diaBtnIcon2: false
              }
            });
          }

        });
        console.log([...cardTable]);
        return cardTable;
      },
      setTracingNodeData(resultData) {
        var that = this;

        function* generator() {
          const cardTable = that.getTracingCardTable(resultData);
          yield cardTable;
          const layoutTable = that.getLayoutData(cardTable);
          //多图换行后设置后面图片的title
          layoutTable.forEach((item1, index1) => {
            item1.cols.forEach((item2, index2) => {
              item2.forEach((item3, index3) => {
                if (index2 > 0 && index3 === 0 && item3.title === '' && item3.width) {
                  const prev = item1.cols[index2 - 1];
                  const prevLastTitles = prev.map(col => col.title).filter(col => col.length > 0);
                  const prevLastTitle = prevLastTitles[prevLastTitles.length - 1] || '';
                  item3.title = prevLastTitle;
                }
              });
            });
          });
          layoutTable.forEach((val, index, arr) => {
            val['index'] = index + 1;
          });
          that.cardTable = layoutTable;
          that.$nextTick(function () {
            that.loading = false;
          });
        }

        genet = generator();
        genet.next();
        hasImage ? null : genet.next();
      },
      // 检测信息
      getTestingData() {
        this.colWidth = 0;
        const selfTestData = JSON.parse(localStorage.selfTestData);
        if (selfTestData && selfTestData != '') {
          this.getTestingCardTable(selfTestData);
        }
      },
      //企业详情
      async getOrgDetailData() {
        this.colWidth = 0;
        const orgDetail = await org.getDetail();
        if (orgDetail) {
          await this.getOrgDetailTable(orgDetail);
        }
      },
      getOtherTestingData() {
        this.colWidth = 0;
        const otherTestData = JSON.parse(localStorage.otherTestData);
        if (otherTestData && otherTestData != '') {
          this.getTestingCardTable(otherTestData);
        }
      },
      async getOrgDetailTable(orgDetail) {
        const rows = orgDetail.Data.Rows;
        const { cardTable, layoutWidth } = await org.createCardTable(rows, this.htmlFontSize);
        this.cardTable = cardTable;
        this.layoutWidth = layoutWidth;
        this.loading = false;
      },
      getTestingCardTable(resultData) {
        let that = this;
        let table = [];
        hasImage = false;

        function* generator() {
          const htmlFontSize = that.htmlFontSize;
          let slideWidth = table.reduce((pre, item, index) => {
            let cardWidth = 0, minWidth = 5.8 * htmlFontSize;
            if (item.cols.length) {
              cardWidth = item.cols.reduce((colpre, col) => {
                return colpre + col[0].width + 61;
              }, -1);
              cardWidth = Math.max(cardWidth, minWidth)
            } else {
              cardWidth = minWidth;
            }
            const maxwidth = cardWidth - 140 - (index + '').length * 60 - item.cardInfo['extraTitleInfo'] * 100;
            var titleInfo = breakLines.breakLinesForCanvas(item.cardInfo['title'], maxwidth < 80 ? 30 : maxwidth - 50, 'bold 30px 微软雅黑'); // -80只是为了保险
            if (titleInfo.length > 1) {
              item.cardInfo['headTtitleWidth'] = cardWidth ? { width: maxwidth + 'px' } : {}
            }
            cardWidth = Math.ceil(cardWidth);
            item.cardInfo['width'] = cardWidth
            return pre + cardWidth + 20 // 20为左边距
          }, -10); // 应该是-20左边距，但为了保险取-10
          that.cardTable = table;
          that.layoutWidth = (slideWidth * 1 + 50) + 'px';
          that.$nextTick(function () {
            that.loading = false;
          });
        }

        genet = generator();
        // 由于检测信息的字段简单，每个检测项对应一个card，每个图片都对应一个col.所以就不进行canvas绘制获取布局数据结构了
        resultData.forEach((card, index) => {
          let cols = [];
          if (card.Images.length) {
            var imgGroups = {};
            //pdf和图片分组，图片为一组，pdf按同名称为一组
            card.Images.forEach((col, index) => {
              if (col.ImagePath) {
                if (col.ImageName.indexOf('__pdf__') < 0) {
                  imgGroups[''] = imgGroups[''] || [];
                  imgGroups[''].push(col);
                } else {
                  imgGroupName = col.ImageName.replace('__pdf__', '').replace(/__\d+.\w+$/, '');
                  imgGroups[imgGroupName] = imgGroups[imgGroupName] || [];
                  imgGroups[imgGroupName].push(col);
                }
              }
            });
            //先显示图片
            imgGroups[''] && imgGroups[''].forEach((col, index) => {
              let img = {
                title: col.ImageName,
                hideTitle: true,
                content: col.ImagePath
              }
              addImageInfo(img, 'content', 'height', 0, this.canvasSize.y);
              hasImage = true;
              cols.push([img]);
            });
            //显示pdf
            for (var imgGroupName in imgGroups) {
              if (imgGroupName) {
                imgGroups[imgGroupName] && imgGroups[imgGroupName].forEach((col, index) => {
                  let img = {
                    title: col.ImageName,
                    hideTitle: true,
                    content: col.ImagePath
                  }
                  addImageInfo(img, 'content', 'height', 0, this.canvasSize.y);
                  hasImage = true;
                  cols.push([img]);
                });
              }
            }
          } else {
            this.colNum++;
          }
          table.push({
            cols: cols,
            cardInfo: {
              title: card.TestingTypeName,
              subTitle: card.TestingItemStandard,
              extraTitleInfo: card.TestingResultType
            },
            index: index + 1
          });
        });
        window.asdasd = this;
        hasImage ? null : genet.next();
      },
      // 保险理赔
      getInsuranceClaimsData() {
        const resultData = JSON.parse(localStorage.resultData);
        let url = '';
        if (resultData.CorpInfo.CorpID == envConfig.specialCorpClaimConfig.zhongNing.corpID) { //中宁
          url = envConfig.specialCorpClaimConfig.zhongNing.claimsUrl + resultData.BatchData.Code;
        } else if (resultData.CorpInfo.CorpID == envConfig.specialCorpClaimConfig.hengShan.corpID) { //横山
          url = envConfig.specialCorpClaimConfig.hengShan.claimsUrl + resultData.BatchData.Code;
        } else if (resultData.isProductOverdue == 1 && resultData.isClaimsisExisted != 1) { //当产品过期并且码是没有理赔过的
          url = envConfig.productOverdueUrl;
        } else {
          url = resultData.isClaimsisExisted == 1 ? envConfig.claimsScheduleUrl : envConfig.claimsUrl;
          //logisticsCode有值时说明原始码为防伪码，值为防伪码转化后的物流码
          if (resultData.logisticsCode) {
            url += resultData.logisticsCode;
            url += '&tag=' + 1;
          } else {
            url += resultData.BatchData.Code;
            url += '&tag=' + 2;
          }
          //添加保险类型参数
          url += '&insureType=' + resultData.insureType;
          //申请理赔时需添加企业id
          if (resultData.isClaimsisExisted != 1) {
            url += '&corpID=' + resultData.CorpInfo.CorpID;
          }
        }
        const leftData = {
          title: '中国平安',
          subTitle: '保险公司',
          content: {
            url: zgpaPath
          },
          contentInfo: '<p classs="zgpaInfo" style="position:relative;bottom:20px;">平安保险是世界500强中国平安集团旗下，提供一站式保险服务，涵盖车险、家财险、意外险等各类保险套餐。</p>'
        };
        const rightData = {
          title: '保险理赔',
          content: {
            url: envConfig.generatorQR + encodeURIComponent(url)
          },
          contentInfo: '<p>手机扫描二维码</p><p>开始保险理赔</p>'
        };
        let isPinAn = true;
        if (typeof resultData.insureCompany === 'string' && resultData.insureCompany.indexOf('平安') < 0) {
          isPinAn = false;
        }
        if (resultData.CorpInfo.CorpID == envConfig.specialCorpClaimConfig.zhongNing.corpID) {
          isPinAn = true;
        }
        if (!isPinAn) {
          leftData.title = '中华联合';
          leftData.content.url = zhonghualogoPath;
          leftData.contentInfo = '';
          url += ('&insureID=' + resultData.insureID + '&insureCompany=' + encodeURIComponent(resultData.insureCompany));
          rightData.content.url = envConfig.generatorQR + encodeURIComponent(url);
        }
        let list = [leftData, rightData];
        this.minCards = list;
        this.$nextTick(function () {
          this.loading = false;
        });
      },
      clickImg(ImgObj) {
        if (!this.zooming) {
          this.zooming = true;
          setTimeout(() => {
            this.zooming = false;
          }, 500);
          let zoomImgObj = {
            show: true,
            url: ImgObj.content,
            width: ImgObj.width,
            height: ImgObj.height
          };
          this.$store.commit('setZoomImg', zoomImgObj);
        }
      },
      touchMoveTrigger(event) {
        if (event) {
          let moveX = '';
          let moveY = '';
          if (event.screenX && event.screenY) {
            moveX = event.screenX;
            moveY = event.screenY;
          } else if (event.changedTouches) {
            moveX = event.changedTouches[0].screenX;
            moveY = event.changedTouches[0].screenY;
          }
          const moveAbsX = Math.abs(this.touchXY.x - moveX);
          const moveAbsY = Math.abs(this.touchXY.y - moveY);
          const now = Date.now();
          if (now - this.touchTriggerTime < 100 && (moveAbsX > 200 || moveAbsY > 200)) {
            return;
          }
          if (moveAbsX > 20 || moveAbsY > 20) {
            this.isTouchMoved = true;
          }
        }
        if (this.isTouchMoved) {
          this.isOnlyTouchStart = false;
        }
      },
      touchTrigger(event) {
        let touchX = '';
        let touchY = '';
        if (event.screenX && event.screenY) {
          touchX = event.screenX;
          touchY = event.screenY;
        } else if (event.changedTouches) {
          touchX = event.changedTouches[0].screenX;
          touchY = event.changedTouches[0].screenY;
        }
        this.touchXY.x = touchX;
        this.touchXY.y = touchY;
        this.isTouchMoved = false;
        this.isOnlyTouchStart = true;
        this.touchTriggerTime = Date.now();
        event.target.removeEventListener(enums.Events.touchMove, this.touchMoveTrigger);
        event.target.addEventListener(enums.Events.touchMove, this.touchMoveTrigger);
      },
      unTouchTrigger(event) {
        if (!this.isTouchMoved) {
          const src = event.target.src;
          let clickImgObj = null;
          this.cardTable.forEach(card => {
            card.cols.forEach(col => {
              col.forEach(row => {
                if (row.content === src && !clickImgObj) {
                  clickImgObj = row;
                }
              });
            });
          });
          if (clickImgObj) {
            this.clickImg(clickImgObj);
          }
        }
        this.$refs.zoomImgs && this.$refs.zoomImgs.length && this.$refs.zoomImgs.forEach(img => {
          img.removeEventListener(enums.Events.touchMove, this.touchMoveTrigger);
        });
      },
      bindTouch() {
        this.$nextTick(() => {
          if (this.$refs.zoomImgs && this.$refs.zoomImgs.length) {
            this.$refs.zoomImgs.forEach(img => {
              if (img.getAttribute('data-isbinded-touch') !== 'yes') {
                img.setAttribute('data-isbinded-touch', 'yes');
                img.addEventListener(enums.Events.touchStart, this.touchTrigger);
                img.addEventListener(enums.Events.touchEnd, this.unTouchTrigger);
                img.addEventListener('touchcancle', this.unTouchTrigger);
              }
            });
          }
        });
      },
      unbindTouch() {
        this.$nextTick(() => {
          if (this.$refs.zoomImgs && this.$refs.zoomImgs.length) {
            this.$refs.zoomImgs.forEach(img => {
              img.removeEventListener(enums.Events.touchStart, this.touchTrigger);
              img.removeEventListener(enums.Events.touchEnd, this.unTouchTrigger);
              img.removeEventListener('touchcancle', this.unTouchTrigger);
            });
          }
        });
      },
      isShowFinger() {
        if (this.isPc) {
          this.$store.commit('changeGestureState', false);
        } else {
          const box = this.$el.querySelector('.scroll-box');
          const inner = this.$el.querySelector('.slide-inner');
          const boxWidth = box ? box.offsetWidth : 0;
          const innerWidth = inner ? inner.offsetWidth : 0;
          const boxScrollLeft = box ? box.scrollLeft : 0;
          this.$store.commit('changeGestureState', boxWidth < innerWidth);
          if (innerWidth - (boxWidth + boxScrollLeft) < 5) {
            this.$store.commit('changeGestureState', false);
          }
        }
      },
      scrollTrigger() {
        clearTimeout(this.scrollTimeOut);
        this.scrollTimeOut = setTimeout(() => {
          this.isShowFinger();
        }, 100)
      },
      calcOffsetTop(dom) {
        let dm = dom;
        let body = document.body;
        let top = 0;
        while (dm !== body) {
          top += dm.offsetTop;
          dm = dm.offsetParent;
        }
        return top;
      },
      imageLoadHandler(index) {
        if (this.isPc) {
          const img = this.$refs.zoomImgs[index];
          let detailCard = img;
          while (detailCard.className.indexOf('detail-card') < 0) {
            detailCard = detailCard.parentElement;
          }
          const imgHeight = img.offsetHeight;
          const imgTop = this.calcOffsetTop(img);
          const cardHeight = detailCard.offsetHeight;
          const cardTop = this.calcOffsetTop(detailCard);
          const distance = (imgHeight + imgTop) - (cardHeight + cardTop);
          if (distance > 0) {
            img.height = imgHeight - distance - 30;
            img.style.width = 'auto';
          }
        }
      },
      //设置区块链信息，为了控制节点中区块链按钮的显示和隐藏
      setblockchain() {
        this.traceDataSave = JSON.parse(localStorage.getItem('traceDataSave')) || ({ traceNodeList: [] });
        this.blockchainDataList = JSON.parse(localStorage.getItem('blockchainList'));
        const blockchainDataList = this.blockchainDataList;
        const blockchainList = [];
        if (blockchainDataList.Result == 200 && blockchainDataList.Data) {
          if (blockchainDataList.Data.rows.length > 0) {
            for (var j = 0; j < this.traceDataSave.traceNodeList.length; j++) {
              const traceNodeID = this.traceDataSave.traceNodeList[j].TraceNodeID;
              for (var i = 0; i < blockchainDataList.Data.rows.length; i++) {
                if (traceNodeID == blockchainDataList.Data.rows[i].nodeId) {
                  blockchainList.push(
                    {
                      main: [{
                        title: '区块编号',
                        content: blockchainDataList.Data.rows[i].blockNo
                      }, {
                        title: '区块Hash',
                        content: blockchainDataList.Data.rows[i].transactionHash
                      }, {
                        title: '上证时间',
                        content: new Date(parseInt(blockchainDataList.Data.rows[i].transactionTime) / 1000000).toLocaleString().replace(/ \d{1,2}:\d{1,2}:\d{1,2}/g, '')
                      }]
                    }
                  );
                }
              }
            }
          }
          this.blockchain.list = blockchainList;
        }
      },
      // 区块链信息
      blockShow(e) {
        this.blockchainDataList = JSON.parse(localStorage.getItem('blockchainList'));
        const blockchainDataList = this.blockchainDataList;
        const ele = e.target.parentNode;
        const btn = Array.from(document.getElementsByClassName('diaBtn'));
        const index = btn.indexOf(ele);
        const traceNodeID = this.traceNodeList[index].TraceNodeID;
        const blockchainList = [];
        if (blockchainDataList.Result == 200 && blockchainDataList.Data) {
          if (blockchainDataList.Data.rows.length > 0) {
            for (var i = 0; i < blockchainDataList.Data.rows.length; i++) {
              if (traceNodeID == blockchainDataList.Data.rows[i].nodeId) {
                blockchainList.push(
                  {
                    title: '区块编号',
                    content: blockchainDataList.Data.rows[i].blockNo
                  }, {
                    title: '区块Hash',
                    content: blockchainDataList.Data.rows[i].transactionHash
                  }, {
                    title: '上证时间',
                    content: new Date(parseInt(blockchainDataList.Data.rows[i].transactionTime) / 1000000).toLocaleString().replace(/ \d{1,2}:\d{1,2}:\d{1,2}/g, '')
                  });
              }
            }
          }
        } else {
          blockchainList.push({ content: blockchainDataList.Data });
        }
        this.blockchain.list = blockchainList;
        this.$refs.blockDialog.style.display = "block";
        this.$refs.mask.style.display = "block";
      },
      closeBlock() {
        this.$refs.blockDialog.style.display = "none";
        this.$refs.mask.style.display = "none";
      },
      async stampShow(e) {
        this.timeStamp = JSON.parse(localStorage.getItem('timeStamp'));
        const timeStamp = this.timeStamp;
        const ele = e.target.parentNode;
        const btn = Array.from(document.getElementsByClassName('diaBtn'));
        const index = btn.indexOf(ele);
        const traceNodeID = this.traceNodeList[index].TraceNodeID;
        const stampList = [];
        if (timeStamp.Result == 200 && timeStamp.Data.row.timeStampInfo) {
          //遍历时间戳接口信息 ，用traceNodeID去匹配对应时间戳信息
          for (var i = 0; i < timeStamp.Data.row.timeStampInfo.length; i++) {
            if (traceNodeID == timeStamp.Data.row.timeStampInfo[i].nodeID) {
              stampList.push(
                {
                  title: '信息名称',
                  content: timeStamp.Data.row.timeStampInfo[i].nodeName
                }, {
                  title: '申请人',
                  content: timeStamp.Data.row.timeStampInfo[i].projectObligee
                }, {
                  title: '申请时间',
                  content: timeStamp.Data.row.timeStampInfo[i].applicationTime
                }, {
                  title: '证件号',
                  content: timeStamp.Data.row.timeStampInfo[i].projectIDCard
                }, {
                  title: '数字指纹',
                  content: timeStamp.Data.row.timeStampInfo[i].dataHash
                });
              this.imagesUrl = timeStamp.Data.row.timeStampInfo[i].imagesUrl
            }
          }
        } else {
          stampList.push({ content: timeStamp.Data.row.timeStampInfo });
        }
        this.stamp.list = stampList;
        this.$refs.stampDialog.style.display = "block";
        this.$refs.mask2.style.display = "block";
      },
      closeStamp() {
        this.$refs.stampDialog.style.display = "none";
        this.$refs.mask2.style.display = "none";
      },
      showStampImg() {
        this.$refs.style.width = '7rem';
        this.$refs.style.position = 'absolute'
      },
    },
    beforeRouteEnter(to, from, next) {
      timer = null;
      next(vm => {
        vm.$store.commit('resizeCardsSize');
        vm.$el.parentNode.style.backgroundImage = 'none';
        vm.$store.commit('setPageTitle', to.query.name);
        const type = to.query.type;
        vm.pageType = type;
        switch (type) {
          case 'trace':
            vm.getTracingData();
            break;
          case 'testReport':
            vm.getTestingData();
            break;
          case 'thirdParty':
            vm.getOtherTestingData();
            break;
          case 'insuranceClaims':
            vm.getInsuranceClaimsData();
            break;
          case 'orgDetail':
            vm.getOrgDetailData();
            break;
          default:
            break;
        }
      });
    },
    mounted() {
      this.bindTouch();
      this.isShowFinger();
      setTimeout(this.isShowFinger, 200);
      setTimeout(this.isShowFinger, 500);
    },
    beforeDestroy() {
      this.unbindTouch();
    }
  }
</script>

<style lang="less" scoped>
  @import '../../assets/less/base.less';

  @red: #bb1d48;

  .index-layout {
    position: absolute;
    left: 0;
    right: 0;
    padding: 0 50px;
    top: 0.3rem;
    bottom: 0.3rem;
    overflow: hidden;

    .scroll-box {
      height: 100%;
      width: 100%;
      overflow: hidden;
      overflow-x: auto;
      border-radius: 0.16rem;
      transform: translate3d(0, 0, 0);
    }
    .slide-inner {
      height: 100%;
      transform: translate3d(0, 0, 0);
      overflow: hidden;
    }
    &.is-mobile {
      .scroll-box {
        &::-webkit-scrollbar, &::-webkit-scrollbar-track, &::-webkit-scrollbar-thumb {
          display: none;
        }
      }
      .detail-card {
        height: 100% !important;
      }
    }

    &.is-pc {
      .scroll-box {
        overflow: hidden;
        overflow-x: auto;
      }
    }

  }

  .card-type {
    position: relative;
    float: left;
    min-width: 5.8rem;
    background: @red;
    padding: .30rem 30px;
    overflow: hidden;
  }

  .card-type + .card-type {
    margin-left: 20px;
  }

  .card-head {
    text-align: left;
    height: 1.3rem;
    float: left;
  }

  .page-type-insuranceClaims .card-head {
    float: none;
  }

  .card-index {
    float: left;
    color: @color-orange;
    height: 1rem;
    line-height: 1rem;
    font-size: 60px;
    padding-right: 20px;
    margin-right: 20px;
    border-right: 1px solid @color-gray;
  }

  .card-content {
    font-size: 0;
  }

  .card-head-title {
    font-size: 0;
  }

  .card-head-title-txt {
    display: inline-block;
    font-size: 0.45rem;
    font-weight: bold;
    text-align: left;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }

  .icon-jchg {
    font-size: 24px;
    color: #58e221;
    vertical-align: middle;
    padding-left: 12px;
    font-weight: normal;
  }

  .card-head-subtitle {
    font-size: 0.384rem;
    color: #333;
    margin-top: .12rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .card-col {
    float: left;
    width: auto;
    margin-top: 0.2rem;
    height: 6.62rem;
    box-sizing: content-box;
  }

  .card-col img {
    width: 100%;
  }

  .card-col + .card-col {
    border-left: 0.01rem solid @border-color;
    margin-left: 30px;
    padding-left: 30px;
  }

  .card-row {
    margin-top: .12rem;
    // line-height: 2em;
  }

  .card-row-key {
    float: left;
    width: 100px;
    font-size: @font-size-normal;
    color: #333;
    font-weight: bold;
    margin-right: 46px;
  }

  .card-row-value {
    margin-left: 146px;
    font-size: @font-size-normal;
    color: #333;
    word-break: break-all;
  }

  .card-row-value-withoutKey {
    margin-left: 0;
  }

  .card-min {
    background: #fff;
    .card-shadow;
  }

  .card-min .card-head {
    text-align: center;
  }

  .card-min .title {
    font-size: 30px;
    font-weight: bold;
  }

  .card-min .subTitle {
  }

  .card-min .card-image {
    height: 4.68rem;
    background: center center no-repeat;
    background-size: contain;
  }

  .card-min img {
    width: 100%;
  }

  .card-min .card-info {
    font-size: 22px;
    line-height: 1.6em;
    text-align: center;
  }

  .zgpaInfo {
    text-align: left;
    text-indent: 2em;
  }

  @media (max-width: 1280px) {
    .zgpaInfo {
      font-size: 22px;
    }
  }

  .card-content-fixed {
    overflow: hidden;
    display: block;
    vertical-align: top;
    height: 57vh;
    width: 118vh;
    margin: 0.37rem auto 0;
  }

  .mask {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 1);
    opacity: 0.5;
    display: none;
  }

  .blockDialog {
    display: none;
    width: 900px;
    height: 90%;
    position: fixed;
    left: 0;
    right: 0;
    margin: auto;
    top: 5%;
    background: #fff;
    z-index: 110;
  }

  .blockTitle {
    font-size: 30px;
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    text-align: center;
    padding-bottom: 35px;
    margin-top: 33px;
    border-bottom: 1px solid rgba(225, 225, 225, 1);
  }

  .card-blockchain-item {
    list-style: none;
  }

  .blockchain-title {
    float: left;
    width: 150px;
    font-size: 26px;
    font-weight: 400;
    color: rgba(170, 170, 170, 1);
    text-align: right;

  }

  .blockchain-content {
    width: 480px;
    margin-left: 47px;
    word-break: break-all;
    font-size: 26px;
    line-height: 30px;
    font-weight: 400;
    float: right;
  }

  .card-blockchain-item {
    margin-top: 41px;
  }

  .card-blockchain-item:first-child {
    margin-top: 0;
  }

  .slide-blockchain {
    overflow-x: hidden;
    overflow-y: scroll;
    width: 121vh;
    height: 100%;
  }

  .slide-blockchain ul {
    width: 898px;
    padding: 41px 49px 50px 149px !important;
  }

  .closeBlock img {
    float: right;
    margin: 27px 24px 0 0;
    width: 18px;
    height: 18px;
    cursor: pointer;
  }

  .blockFoot {
    font-size: 22px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: rgba(170, 170, 170, 1);
    line-height: 36px;
    margin: 15px auto 0;
    text-align: center;
  }

  .blockIcon {
    width: 195px;
    height: 137px;
    position: absolute;
    top: 300px;
    right: 55px;
  }

  .blockIcon img {
    width: 100%;
    height: 100%;
  }

  .stampDialog {
    display: none;
    height: 90%;
    width: 90vw;
    position: fixed;
    left: 0;
    right: 0;
    margin: auto;
    top: 5%;
    background: #fff;
    z-index: 110;
  }

  .stampDialog .card-content-fixed {
    height: 37vw !important;
    width: 49.8vw !important;
    margin-top: 2vw;
    display: inline-block;
  }

  .stampTitle {
    font-size: 30px;
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    text-align: center;
    padding-bottom: 35px;
    margin-top: 33px;
    border-bottom: 1px solid rgba(225, 225, 225, 1);
  }

  .card-stamp-item {
    list-style: none;
  }

  .stamp-title {
    float: left;
    font-size: 26px;
    font-weight: 400;
    color: rgba(170, 170, 170, 1);
    text-align: right;

  }

  .stamp-content {
    width: 24vw;
    margin-left: 2vw;
    word-break: break-all;
    font-size: 26px;
    line-height: 30px;
    font-weight: 400;
    float: right;
  }

  .card-stamp-item {
    margin-top: 41px;
  }

  .card-stamp-item:first-child {
    margin-top: 0;
  }

  .slide-stamp {
    overflow-x: hidden;
    overflow-y: scroll;
    height: 30.7vw;
    width: 51vw;
  }

  .slide-stamp ul {
    width: 100%;
    padding: 41px 49px 50px 70px !important;
  }

  .closeStamp img {
    float: right;
    margin: 27px 24px 0 0;
    width: 18px;
    height: 18px;
    cursor: pointer;
  }

  .stampFoot {
    font-size: 22px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: rgba(170, 170, 170, 1);
    line-height: 36px;
    margin: 0 auto;
    text-align: center;
  }

  .stampIcon {
    width: 133px;
    height: 132px;
    position: absolute;
    top: 280px;
    right: 104px;
  }

  .stampIcon img {
    width: 100%;
    height: 100%;
  }

  .stampImg {
    width: 23vw;
    margin: 2vw 7.8vw 0 2.3vw;
    display: inline-block;
    vertical-align: top;
  }

  .stampImg img {
    width: 100%;
    height: 30.7vw;
    display: block;
  }

  .imgSub {
    font-size: 22px;
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    color: rgba(170, 170, 170, 1);
    text-align: center;
    margin: 0 auto;
  }

  .diaBtn {
    text-align: right;
    float: right;
    font-size: 22px;
    color: #2095f2;
  }

  .diaBtn div:first-child {
    margin-bottom: 10px;
  }

  .diaBtnIcon {
    display: inline-block;
    width: 24px;
    height: 24px;
    vertical-align: middle;
  }

  .diaBtnIcon1 {
    background: url("../../../static/diaBtn-icon1.png") no-repeat;
    background-size: 100% 100%;
    margin-right: 7px;
  }

  .diaBtnIcon2 {
    background: url("../../../static/diaBtn-icon2.png") no-repeat;
    background-size: 100% 100%;
    margin-right: 7px;
  }
</style>



// WEBPACK FOOTER //
// index.vue?29cb4a26